import { Link } from '@tanstack/react-router';
import { getActiveOrFirstUserId } from 'cpool-utils';
import { useTranslation } from 'react-i18next';

import { PanelSection } from './PanelSection';
import { useGetUserNameById } from '~/features/leadDetails/hooks/useGetUserNameById';
import useLead from '~/features/leadDetails/hooks/useLead';

type Props = {
    loanRequestId: string;
};

export const CrmLinkageSection = ({ loanRequestId }: Props) => {
    const { t } = useTranslation();
    const { data: lead } = useLead(loanRequestId);
    const adviserName = useGetUserNameById(lead ? getActiveOrFirstUserId(lead) : undefined);

    if (!lead) return null;

    const caseLabel = lead.customId ?? lead.id.slice(0, 8).toUpperCase();

    return (
        <PanelSection title={t('WHATSAPP_CHAT.USER_INFO.CRM.TITLE')}>
            <div className="flex items-center gap-2 py-1.5 text-sm text-midnight">
                <span className="w-24 shrink-0 text-grey">{t('WHATSAPP_CHAT.USER_INFO.CRM.ADVISER')}</span>
                <span className="font-medium">
                    {adviserName
                        ? `${adviserName.firstName} ${adviserName.lastName}`
                        : t('WHATSAPP_CHAT.USER_INFO.CRM.UNASSIGNED')}
                </span>
            </div>
            <div className="flex items-center gap-2 py-1.5 text-sm text-midnight">
                <span className="w-24 shrink-0 text-grey">{t('WHATSAPP_CHAT.USER_INFO.CRM.CASE')}</span>
                <Link
                    to="/leads/details/$leadId"
                    params={{ leadId: lead.id }}
                    className="font-medium text-blue-text hover:underline"
                >
                    {caseLabel}
                </Link>
            </div>
        </PanelSection>
    );
};
